import type {
  ActivitySubscriptionPerRoleUpdateData,
  ActivitySubscriptions,
} from '@core/activities-types';
import { createSingleEntityStore, pipeState } from '@core/ngrx-legacy';

import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<ActivitySubscriptions | null>()(
    EntityStoreKey.activitySubscriptionsPerRole,
    {
      customActions: adapter => ({
        fetch: (state, payload: number) => adapter.markAsPending(state),
        update: (state, payload: ActivitySubscriptionPerRoleUpdateData) =>
          adapter.markAsPending(state),
        resetToDefaults: (state, payload: number) => adapter.markAsPending(state),
        resetToDefaultsSuccess: (state, payload: ActivitySubscriptions) =>
          pipeState(adapter.save(state, payload), next => adapter.markAsLoaded(next)),
      }),
    },
  );

export {
  actions as ActivitySubscriptionsPerRoleActions,
  selectors as ActivitySubscriptionsPerRoleSelectors,
  reducer as ActivitySubscriptionsPerRoleReducer,
  namespace as ActivitySubscriptionsPerRoleNamespace,
};
